import { pluralise } from '../utils';
import { ImpactType } from './units';

export const impactTypeToSummaryText: Record<ImpactType, (quantity: number, carbonUnit?: 'tonne' | 'kg') => string> = {
  [ImpactType.TREES]: (quantity: number) => `${pluralise(quantity, 'tree')} funded`,
  [ImpactType.CARBON_OFFSETS]: (quantity: number, carbonUnit = 'tonne') =>
    `${carbonUnit === 'kg' ? `${quantity.toLocaleString()} kg` : pluralise(quantity, 'tonne')} CO₂e avoided`,
  [ImpactType.CARBON_REMOVAL]: (quantity: number, carbonUnit = 'tonne') =>
    `${carbonUnit === 'kg' ? `${quantity.toLocaleString()} kg` : pluralise(quantity, 'tonne')} CO₂e removed`,
  [ImpactType.HABITAT_RESTORATION]: (quantity: number) => `${quantity.toLocaleString()}m² habitat restored`,
};
